import React, { useState, useEffect } from 'react';
import { RespResumeOtherDataAttachmentList } from '../../../../item/ItemResume';
import { AttachmentItems } from '../../Res/AttachmentItems';

export function ItemAttachment({ item, action, isEdit = true }) {
    const [mAttachment, setmAttachment] = useState({})
    const [mAttachmentList, setAttachmentList] = useState([])

    var parameterArray = [
        { key: "attachment1", name: "附件  1", br: false, editInfo: true },
        { key: "attachment2", name: "附件  2", br: false, editInfo: true },
        { key: "attachment3", name: "附件  3", br: false, editInfo: true },
    ]

    useEffect(() => {
        //console.log("ItemAttachment")
        var mRespResumeOtherDataAttachmentList = new RespResumeOtherDataAttachmentList({})
        mRespResumeOtherDataAttachmentList.fromJson(mAttachment, parameterArray)
        //console.log(mRespResumeOtherDataAttachmentList)
        setAttachmentList(mRespResumeOtherDataAttachmentList.attachmentList)
        if (action !== undefined) {
          action(mRespResumeOtherDataAttachmentList.attachmentList)
        }
    }, [])

    useEffect(() => {

        //console.log(JSON.stringify(item) === JSON.stringify(mAttachment))
        if (item !== undefined && JSON.stringify(item) !== JSON.stringify(mAttachment) && Object.keys(item).length !== 0) {
            setmAttachment(item)
            var mRespResumeOtherDataAttachmentList = new RespResumeOtherDataAttachmentList({})
            mRespResumeOtherDataAttachmentList.fromJson(item, parameterArray)
            //console.log(mRespResumeOtherDataAttachmentList)
            setAttachmentList(mRespResumeOtherDataAttachmentList.attachmentList)
            if (action !== undefined) {
              action(mRespResumeOtherDataAttachmentList.attachmentList)
            }
        }
    }, [item])


    function setAttachment(key, attachment) {
        //console.log(key)
        //console.log(attachment)
        //console.log(mAttachmentList)
        //console.log("setAttachment")
        //console.log(key)
        //console.log(attachment)
        mAttachmentList[key] = attachment
        setAttachmentList(mAttachmentList)
        //console.log(mAttachmentList)
        if (action !== undefined) {
          action(mAttachmentList)
        }
    }

    var content =
        <>
            {
                parameterArray.map((f, i) => (
                    <AttachmentItems key={"pm" + i} index={f.key} parameter={f} attachment={mAttachmentList[f.key]} setAttachment={setAttachment} isEdit={isEdit} />
                ))
            }
            {isEdit ?
                <>
                    <div className="hr-line-dashed"></div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="col-md-2">
                                <p>支援的檔案格式</p>
                            </div>
                            <div className="col-md-10">
                                <strong>文件：&nbsp;.pdf&nbsp;&nbsp;.doc&nbsp;&nbsp;.docx&nbsp;&nbsp;；&nbsp;&nbsp;圖片：&nbsp;.jpg&nbsp;&nbsp;.jpeg&nbsp;&nbsp;.png；&nbsp;&nbsp;檔案大小&lt; 5MB   </strong>
                            </div>
                        </div>
                    </div>
                </>
                : <></>
            }
        </>


    return (
        <>
            {content}
        </>
    )
}
